<template>
  <div v-if="isAllowed">
    <slot />
  </div>
  <div v-else-if="$slots.fallback">
    <slot name="fallback" />
  </div>
</template>

<script>
import { useAppStore } from '@/store/app';

export default {
  name: 'PermissionGate',
  props: {
    permission: {
      type: String,
      default: '',
    },
    anyOf: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    store() {
      return useAppStore();
    },
    isAllowed() {
      if (this.anyOf.length) {
        return this.store.hasAnyPermission(this.anyOf);
      }

      return this.store.hasPermission(this.permission);
    },
  },
};
</script>
